import React from 'react';
import { useForm } from '../../hooks/useForm';
import { consent, email, required, validateCvFile } from '../../utils/validation';
import { FormField } from '../ui/FormField';
import { ConsentCheckbox } from '../ui/ConsentCheckbox';
import { FormStatus } from '../ui/FormStatus';
import { Button } from '../ui/Button';
import { CvUpload } from './CvUpload';
import type { Job } from '../../types/content';
export function ApplicationForm({
  job
}: {
  job: Job;
}) {
  const {
    values,
    errors,
    status,
    setField,
    setFieldError,
    handleSubmit,
    reset
  } = useForm({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    linkedin: '',
    cv: '',
    note: '',
    similar: false,
    consent: false
  }, {
    firstName: required('First name'),
    lastName: required('Last name'),
    email: email(),
    cv: v => v ? undefined : 'Please attach your CV (PDF or Word, up to 5 MB).',
    consent
  });
  const onSelectFile = (file: File) => {
    const problem = validateCvFile(file);
    if (problem) {
      setField('cv', '');
      setFieldError('cv', problem);
      return;
    }
    setField('cv', file.name);
  };
  return <form noValidate onSubmit={handleSubmit} className="space-y-5" aria-label={`Apply for ${job.title}`} data-id="element-65" data-mp="1z5yobsc3d60f">
      <div className="grid gap-5 sm:grid-cols-2" data-id="element-66" data-mp="1l6fs9xwk1l4h">
        <FormField name="firstName" label="First name" required autoComplete="given-name" value={values.firstName} error={errors.firstName} onChange={v => setField('firstName', v)} data-id="element-67" data-mp="1q5aivm0rkdz5" />
        <FormField name="lastName" label="Last name" required autoComplete="family-name" value={values.lastName} error={errors.lastName} onChange={v => setField('lastName', v)} data-id="element-68" data-mp="1g7ckw6t3r2tc" />
        <FormField name="email" label="Email" type="email" required autoComplete="email" value={values.email} error={errors.email} onChange={v => setField('email', v)} data-id="element-69" data-mp="12eejo3tzaghv" />
        <FormField name="phone" label="Phone" type="tel" autoComplete="tel" value={values.phone} onChange={v => setField('phone', v)} data-id="element-70" data-mp="sijwcvet7x8r" />
        <FormField name="linkedin" label="LinkedIn profile URL" type="url" className="sm:col-span-2" placeholder="https://" value={values.linkedin} onChange={v => setField('linkedin', v)} data-id="element-71" data-mp="2z6ajky2c4cmd" />
      </div>
      <CvUpload fileName={values.cv} error={errors.cv} onSelect={onSelectFile} onClear={() => setField('cv', '')} data-id="element-72" data-mp="2qe09rhvcq95n" />
      <FormField name="note" label="Note to the consultant" type="textarea" rows={3} placeholder="Your notice period, motivation or anything relevant." value={values.note} onChange={v => setField('note', v)} data-id="element-73" data-mp="2lffgk2eiopqp" />
      <div className="space-y-3" data-id="element-74" data-mp="394hwn5ti6aj3">
        <ConsentCheckbox name="similar" checked={values.similar} onChange={v => setField('similar', v)} data-id="element-75" data-mp="393oxor0scpbi">
          Let me know about similar opportunities.
        </ConsentCheckbox>
        <ConsentCheckbox checked={values.consent} error={errors.consent} onChange={v => setField('consent', v)} data-id="element-76" data-mp="1xpukqix9ly00">
          I have read the candidate privacy notice and agree to Corventa processing my application. My details will not be shared with any employer without my permission.
        </ConsentCheckbox>
      </div>
      <FormStatus status={status} onReset={reset} data-id="element-77" data-mp="1nmfssulwgxvc" />
      <Button type="submit" size="lg" variant="navy" arrow className="w-full" data-id="element-78" data-mp="1nj1ubxgcx8t6">
        Submit application
      </Button>
    </form>;
}